import React from "react";
import { Col, Label, Input, FormFeedback } from "reactstrap";
const FirstNameField = (data) => {
    const { props, label, required } = data;
    return (
        <>
            <Label htmlFor='firstName' sm={2}>
                {label ? label : "First Name"}
                {required ? <small className='text-danger'>*</small> : ""}
            </Label>
            <Col sm={4}>
                <Input
                    id='firstName'
                    name='firstName'
                    type='text'
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    value={props.values.firstName || ""}
                    invalid={props.touched.firstName && props.errors.firstName ? true : null}
                />
                <FormFeedback>{props.errors.firstName}</FormFeedback>
            </Col>
        </>
    );
};
export default FirstNameField;
